import React, {useEffect, useState} from "react";
import {
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Table,
    TableCell,
    TableRow,
    TextField
} from "@material-ui/core";
//import DateTimePicker from "react-datetime-picker/src/DateTimePicker";
import DatePicker from "react-date-picker";

export function RseDialog(props){
    const {onDock} = props;
    const [open,setOpen] = useState(false);
    const [rse, setRse] = useState(null);
    const [onOk, setOnOk] = useState(() => () => alert("no onOk set"));
    const show = (rse, onOk) => {
        setOpen(true);
        setRse(rse);
        setOnOk(() => onOk)
    };

    useEffect(() => {
        onDock(show);
    },[]); // eslint-disable-line react-hooks/exhaustive-deps

    return <Dialog open={open} onclose={() => setOpen(false)}

            >
        <DialogTitle>RSE</DialogTitle>
        <DialogContent>
            <DialogContentText>

            </DialogContentText>
            <Table style={{height:'400px'}}>
                <TableRow>
                    <TableCell>For Client</TableCell>
                    <TableCell>
                        <Chip
                            label={(rse || {}).clientTitle}/>

                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Description</TableCell>
                    <TableCell>
                        <TextField style={{width:'400px'}}
                                   value={(rse || {}).title}
                                   onChange={e => setRse({...rse, title:e.target.value})}
                                   />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell>Scheduled</TableCell>
                    <TableCell>
                        <DatePicker style={{width:'400px'}} locale='en-US'
                                    value={(rse || {}).start}
                                    onChange={dt => {
                                        setRse({...rse, start:dt});
                                    }}
                        />
                    </TableCell>
                </TableRow>
            </Table>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={() => {
                if(!rse){
                    alert('No RSE');
                    return;
                }
                if(!rse.start){
                    alert('Please set up scheduled date');
                    return;
                }
                if(!rse.title){
                    alert('Please give it a description, like Quarter One, or First Half Year');
                    return;
                }
                setOpen(false);
                onOk(rse);
            }}>OK</Button>
        </DialogActions>
    </Dialog>
}